export default __webpack_public_path__ + "static/media/3011.98d28657.jpg";